module.exports = __webpack_public_path__ + "assets/img/index-box2-3.2e8ddcaf.png";